import { render, staticRenderFns } from "./DNSDataTable.vue?vue&type=template&id=34c1a7a0&scoped=true"
import script from "./DNSDataTable.vue?vue&type=script&lang=js"
export * from "./DNSDataTable.vue?vue&type=script&lang=js"
import style0 from "./DNSDataTable.vue?vue&type=style&index=0&id=34c1a7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1a7a0",
  null
  
)

export default component.exports